<template>
    <div class="SchoolDisplayAndEdit">
        <!--DISPLAY TABLE-->
        <b-container>
            <b-row style="overflow-x:auto;">
                <b-col cols="11">
                    <vuetable :fields="TableFields"
                              :data="TableData"
                              pagination-path=""
                              :api-mode="false"
                              class="vue-datatable"
                              :row-class="onRowClass">

                        <template slot="DetailView" scope="props">
                            <div class="DetailView">
                                <span class="underline pointer" @click="ShowDetailView(props.rowData)"><span v-html="props.rowData.Name"></span> <font-awesome-icon :icon="['fa', 'edit']" v-if="EditMode" /></span>
                            </div>
                        </template>
                    </vuetable>
                </b-col>
                <b-col cols="1">
                    <div v-if="EditMode && CheckPermission(EditPermission)" class="vert-icons">
                        <b-row>
                            <font-awesome-icon :icon="['fa', 'plus']" v-on:click="ShowAddEditRecord()" class="pointer olive-green-text" />
                        </b-row>
                    </div>
                </b-col>
            </b-row>
        </b-container>

        <!--ADD AND EDIT AND DETAIL MODAL-->
        <b-modal ref="modal-record" size="lg" :title="ModalAddEditTitle" hide-footer>
            <b-container v-if="EditMode == false && TargetRecord.Id">
                <b-row>
                    <b-col>
                        <h3>Relationship General Info</h3>
                        <p><span class="bold">Name: </span>{{TargetRecord.Name}}</p>
                        <p><span class="bold">Connected to Church: </span>{{TargetRecord.IsChurchRelationshipString}}</p>
                        <p><span class="bold">Church/Organization: </span>{{TargetRecord.AgencyName}}</p>
                        <p><span class="bold">Relationship Started: </span>{{formatDate(TargetRecord.StartDate,'MM/DD/YY')}}</p>
                        <p><span class="bold">Relationship Ended: </span>{{formatDate(TargetRecord.EndDate,'MM/DD/YY')}}</p>
                    </b-col>
                    <b-col>
                        <h3>Additional Information</h3>
                        <p><span class="bold">Source of Relationship: </span>{{TargetRecord.RelationshipSource}}</p>
                        <p><span class="bold">Nature/Description: </span>{{TargetRecord.NatureDescriptionOfRelationship}}</p>
                        <p><span class="bold">Contact Frequency: </span>{{TargetRecord.AverageFrequencyOfContact}}</p>
                        <p><span class="bold">How will relationship sustain client after Olive Crest: </span>{{TargetRecord.PostProgramBenefits}}</p>
                    </b-col>
                </b-row>
                <b-row class="modal-btn-row">
                    <div class="modal-btn-row-div">
                        <b-button size="md" variant="secondary" @click="CancelDetail()">
                            CLOSE
                        </b-button>
                    </div>
                </b-row>
            </b-container>
            <b-container v-if="EditMode">
                <b-form @submit="AddEditRecord" autocomplete="off">
                    <b-row>
                        <b-col>
                            <h3>Relationship General Info</h3>
                            <div class="form-group">
                                <label>Name of Person (or persons):</label>
                                <input type="text" required class="form-control" v-model="TargetRecord.Name" />
                            </div>
                            <div class="form-group">
                                <label>Is this Relationship Connected to a Church?</label>
                                <select required class="form-control" v-model="TargetRecord.IsChurchRelationship">
                                    <option value=""></option>
                                    <option :value="true">Yes</option>
                                    <option :value="false">No</option>
                                </select>
                            </div>
                            <div class="form-group" v-if="TargetRecord.IsChurchRelationship != null">
                                <label v-if="TargetRecord.IsChurchRelationship">Name of Church:</label>
                                <label v-else>Name of Group, Organization, Agency that {{TargetRecord.Name}} is a part of:</label>
                                <input type="text" required class="form-control" v-model="TargetRecord.AgencyName" />
                            </div>
                            <div class="form-group">
                                <label>When did Relationship Start?</label>
                                <flat-pickr v-model="TargetRecord.StartDate" class="form-control" required :config="DateConfig"></flat-pickr>
                            </div>
                            <div class="form-group">
                                <label>When did Relationship End? (leave blank for current relationship)</label>
                                <flat-pickr v-model="TargetRecord.EndDate" class="form-control" :config="DateConfig"></flat-pickr>
                            </div>
                        </b-col>
                        <b-col>
                            <h3>Additional Information</h3>
                            <div class="form-group">
                                <label>How did {{ClientFirstName}} get connected to {{TargetRecord.Name}}?</label>
                                <select required class="form-control" v-model="TargetRecord.RelationshipSource">
                                    <option value=""></option>
                                    <option value="CE Team">CE Team</option>
                                    <option value="Other Olive Crest Staff">Other Olive Crest Staff</option>
                                    <option value="Preexisting Relationship">This was a preexisting relationship</option>
                                    <option value="Client Family">Client's Family'</option>
                                    <option value="Other">Other Source</option>
                                </select>
                            </div>
                            <div class="form-group">
                                <label>Nature/Description of the Relationship:</label>
                                <input type="text" class="form-control" required v-model="TargetRecord.NatureDescriptionOfRelationship" />
                            </div>
                            <div class="form-group">
                                <label>About how often does {{ClientFirstName}} have contact with {{TargetRecord.Name}} ?</label>
                                <select required class="form-control" v-model="TargetRecord.AverageFrequencyOfContact">
                                    <option value=""></option>
                                    <option value="Daily">Daily</option>
                                    <option value="Weekly">Weekly</option>
                                    <option value="BiMonthly">Twice a Month</option>
                                    <option value="Monthly">Monthly</option>
                                    <option value="BiAnnually">A few times a year</option>
                                    <option value="Annually">Once a Year</option>
                                    <option value="LessThanAnnually">Less than once a year</option>
                                </select>
                            </div>
                            <div class="form-group">
                                <label>How will {{TargetRecord.Name}} help sustain/support/strengthen {{ClientFirstName}} when they leave Olive Crest?</label>
                                <textarea rows="4" type="text" class="form-control" v-model="TargetRecord.PostProgramBenefits"></textarea>
                            </div>
                        </b-col>
                    </b-row>
                    <b-row class="modal-btn-row">
                        <div class="modal-btn-row-div">
                            <b-button size="md" variant="secondary" @click="CancelDetail()">
                                CANCEL
                            </b-button>
                            <b-button size="md" variant="success" type="submit" v-if="EditMode">
                                SAVE
                            </b-button>
                            <b-button size="md" variant="danger" @click="DeleteRecord()" type="button" v-if="TargetRecord.Id">
                                DELETE
                            </b-button>
                        </div>
                    </b-row>
                </b-form>
            </b-container>
        </b-modal>
    </div>

</template>

<script>
    //import icons
    import { library } from '@fortawesome/fontawesome-svg-core';
    import { faEdit } from '@fortawesome/free-solid-svg-icons';
    library.add(faEdit);
    import { faPlus } from '@fortawesome/free-solid-svg-icons';
    library.add(faPlus);
    import { faTrashAlt } from '@fortawesome/free-solid-svg-icons';
    library.add(faTrashAlt);
    import flatPickr from 'vue-flatpickr-component';
    import 'flatpickr/dist/flatpickr.css';

    import Vuetable from 'vuetable-2/src/components/Vuetable';

    export default {
        props: [
            "EditMode",//bool
            "EditPermission",//string
            "ChartId",//guid
            "ClientFirstName"//string
        ],
        data: function () {
            return {
                TargetRecord: {},
                ModalAddEditTitle: "",
                LoadedRecords: [],
                //config
                TableFields: [
                    {
                        name: "__slot:DetailView",
                        title: "NAME"
                    },
                    {
                        name: "IsChurchRelationshipString",
                        title: "CHURCH RELATIONSHIP"
                    },
                    {
                        name: "AgencyAndNatureCombined",
                        title: "DESCRIPTION"
                    },
                    {
                        name: "StartDate",
                        title: "STARTED",
                        callback: 'formatDate|MM/DD/YY',
                    },
                    {
                        name: "EndDate",
                        title: "ENDED",
                        callback: 'formatDate|MM/DD/YY',
                    }
                ],
                DateConfig: {
                    dateFormat: 'Y-m-d',
                    allowInput: true,
                    altInput: true,
                    altFormat: 'm/d/Y',
                    required: false  
                }
                
            };
        },
        methods: {
            onRowClass (dataItem, index) {
                return (dataItem.EndDate == null) ? 'current-record' : '';
            },
            GetRecords() {
                this.$MasterAPI.ExecuteRequest("GET", "Core/InformalRelationships", { ClientSubProgramMembershipID: this.ChartId }, this.GetRecordsSuccess, () => { },false)
            },
            GetRecordsSuccess(response) {
                this.LoadedRecords = response.data.data;
            },
            ShowDetailView(record) {
                this.TargetRecord = JSON.parse(JSON.stringify(record));
                
                if (this.EditMode) {
                    this.ModalAddEditTitle = "Editing " + record.Name;
                } else {
                    this.ModalAddEditTitle = "Viewing " + record.Name;
                }
                this.$refs["modal-record"].show();
            },
            ShowAddEditRecord() {
                this.TargetRecord = {};
                this.ModalAddEditTitle = "Add New Relationship";
                this.$refs["modal-record"].show();
            },
            AddEditRecord(e) {
                e.preventDefault();
                this.TargetRecord.ClientSubProgramMembershipID = this.ChartId;
                //get person data here
                this.$MasterAPI.ExecuteRequest("POST", "Core/InformalRelationships", this.TargetRecord, this.AddEditRecordSuccess, () => { }, true);
            },
            AddEditRecordSuccess(response) {
                this.GetRecords();
                this.$refs["modal-record"].hide();
            },
            DeleteRecord() {
                this.$MasterAPI.ExecuteRequest("DELETE", "Core/InformalRelationships/" + this.TargetRecord.Id, {}, this.DeleteRecordSuccess, () => { }, true);
            },
            DeleteRecordSuccess(response) {
                this.GetRecords();
                this.$refs["modal-record"].hide();
            },
            CancelDetail() {
                this.$refs['modal-record'].hide();
            },
            formatDate (value, fmt = 'D MMM YYYY') {
              return (value == null || value == '')
                ? ''
                : moment(value, 'YYYY-MM-DD').format(fmt)
            },
            CheckPermission(permissionName) {
                return this.$store.getters["User.PrivateProfile.CheckPermission"](permissionName);
            },
        },
        components: {
            flatPickr,
            Vuetable
        },
        computed: {
            TableData: function () {
                return this.LoadedRecords;
            }
        },
        mounted() {
            this.GetRecords();
        }
    }
</script>

<style scoped>
    .vert-icons div {
        margin-top:10px;
    }
    /deep/ tbody tr.current-record {
        font-weight: bold;
    }
    table {
        table-layout:auto;
    }
    .vue-datatable {
        width: 100%;
        display: inline-table;
        overflow-x: auto;
    }
</style>